import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'
import { offlineDB } from '../services/offlineDB'
import { LogIn } from 'lucide-react'
import './Login.css'

export default function Login({ onLogin }) {
  const [usuarios, setUsuarios] = useState([])
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    cargarUsuarios()
  }, [])

  async function cargarUsuarios() {
    try {
      if (navigator.onLine) {
        console.log('📥 Cargando usuarios desde Supabase...')
        const { data } = await supabase.from('users').select('*').order('username')
        if (data) {
          await offlineDB.cacheUsers(data)
          setUsuarios(data)
          console.log('✅ Usuarios cargados:', data)
          return
        }
      }
      
      // Cargar desde caché
      console.log('📱 Cargando usuarios desde caché...')
      const cached = await offlineDB.getCachedUsers()
      setUsuarios(cached || [])
      console.log('✅ Usuarios desde caché:', cached)
    } catch (error) {
      console.error('Error cargando usuarios:', error)
    }
  }

  async function handleLogin(e) {
    e.preventDefault()
    setError('')

    if (!username) {
      setError('Selecciona un usuario')
      return
    }

    if (!password) {
      setError('Ingresa la contraseña')
      return
    }

    setLoading(true)

    try {
      const usuario = usuarios.find(u => u.username === username && u.password === password)

      if (!usuario) {
        setError('Contraseña incorrecta')
        setLoading(false)
        return
      }

      console.log('✅ Login exitoso:', usuario.username)
      localStorage.setItem('currentUser', JSON.stringify(usuario))
      onLogin(usuario)
    } catch (error) {
      console.error('Error en login:', error)
      setError('Error al iniciar sesión')
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-icon">🥖</div>
          <h1>Panadería Hermanos Alonso</h1>
          <p>Sistema de Gestión de Reparto</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label>Usuario</label>
            <select
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            >
              <option value="">Seleccionar usuario...</option>
              {usuarios.map(u => (
                <option key={u.id} value={u.username}>{u.username}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
              required
            />
          </div>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <button type="submit" className="login-button" disabled={loading}>
            <LogIn size={20} />
            {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
          </button>
        </form>
      </div>
    </div>
  )
}
